import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LibAuthService as MatAuthService } from 'ngx-mat-auth';
import { LibAuthService, LibBusService } from 'ngx-mat-base-comp';
import { PermissionsBase } from './permissions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly tokenDurationMs: number = 10 * 60 * 60 * 1000; // Default 10 hours
  private readonly EXPIRATION_KEY = 'token_expiration_time';
  constructor(
    private libBusService: LibBusService,
    private libMatAuthService: MatAuthService,
    private libAuthService: LibAuthService
    ) {
    }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      const _route = route as any;
      if (route.data['module'] && route.data['module'] !== '') {
        this.libBusService.module =  route.data['module'];
      }
      if ((route as any)._routerState) {
        this.libBusService.initialRoute =  _route._routerState?.url?.split('?')[0];
        if (_route.queryParams && Object.keys(_route.queryParams).length > 0) {
          this.libBusService.initialQueryParams = _route.queryParams;
        }
      }
      if (await this.libMatAuthService.isUserLoggedIn()) {
        if (await this.libAuthService.hasAccess(PermissionsBase.Hub)) {
          
          await this.libAuthService.loadPermissions(this.libBusService.impersonateUser?.groups || null);              
          this.libAuthService.authorizedUser();
          
          return true;

        } else {

          this.libAuthService.unauthorizedUser();
          return false;

        }
      } else {

       // this.auth.federatedSignIn();
          this.refreshSessionExpiration();
          this.libMatAuthService.federatedSignIn();
        return false;
        
      }
  }

  public refreshSessionExpiration(): void {
    const expirationTime = new Date().getTime() + this.tokenDurationMs;
    localStorage.setItem(this.EXPIRATION_KEY, expirationTime.toString());
  }

}
